// ✅ src/components/safety/view/RiskcheckView.jsx
//Changed
import React from "react";
import TableCell from "../../common/ui/TableCell";

export default function RiskcheckView({ doc }) {
  const meta = doc?.meta || {};

  // // === 기본 정보(form + meta) ===
  // const title = doc?.title || "(제목 없음)";
  // const docDate = meta.doc_date || "-";
  // const author = doc?.author || meta.author || "-";
  // const status = doc?.status || "none";

  // === 평가 정보 ===
  // (작성 화면 RiskcheckEditor 기준 key/라벨 통일)
  const docDate = meta.doc_date || doc?.doc_date || "-"; // 작성 화면: '평가일'
  const note = meta.note || "";

  const hazards = Array.isArray(meta.hazards) ? meta.hazards : [];
  const improvements = Array.isArray(meta.risk_improvements)
    ? meta.risk_improvements
    : [];

  return (
    <div
      className="w-full px-2 space-y-3 text-sm text-gray-800 min-w-0 overflow-x-hidden"
      style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
    >
      {/* 평가 요약 */}
      {/* <div className="mb-2 text-sm font-semibold">위험성 평가 요약</div> */}
      <table className="min-w-full text-sm border">
        <tbody>
          <tr>
            <TableCell label="평가일" value={docDate} colSpan={3} />
            {/* <TableCell label="공정" value={process} /> */}
          </tr>
          {/* <tr>
            <TableCell label="작업 위치" value={location} />
            <TableCell label="평가자" value={assessor} />
          </tr> */}
          {/* <tr>
            <TableCell label="평가 방법" value={method} />
            <TableCell label="위험 수준" value={riskLevel} />
          </tr> */}
          {/* <tr>
            <TableCell
              label="심각도 / 가능성"
              value={`${severity || "-"} / ${likelihoodDisplay}`}
            />
            <TableCell
              label="확인자 / 승인자"
              value={`${reviewer || "-"} / ${approver || "-"}`}
            />
          </tr> */}
          <tr>
            <TableCell label="비고" value={note} colSpan={3} />
          </tr>
        </tbody>
      </table>

      {/* 위험 요소 */}
      <div className="text-sm font-semibold mt-4 mb-2">위험 요소</div>
      {hazards.length === 0 ? (
        <div className="text-slate-500 text-sm">
          입력된 위험 요소가 없습니다.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border">
            <thead className="bg-gray-50">
              <tr>
                <th className="border px-2 py-1">위험 요소</th>
                <th className="border px-2 py-1">예상 결과</th>
                <th className="border px-2 py-1">기존 대책</th>
              </tr>
            </thead>
            <tbody>
              {hazards.map((r, idx) => (
                <tr key={idx}>
                  <td className="border px-2 py-1">{r.hazard || "-"}</td>
                  <td className="border px-2 py-1">{r.consequence || "-"}</td>
                  <td className="border px-2 py-1">
                    {r.existing_measures || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 개선 계획 */}
      <div className="mt-4 mb-2 text-sm font-semibold">개선 계획</div>
      {improvements.length === 0 ? (
        <div className="text-slate-500 text-sm">
          입력된 개선 계획이 없습니다.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border">
            <thead className="bg-gray-50">
              <tr>
                <th className="border px-2 py-1">개선 대상</th>
                <th className="border px-2 py-1">개선 계획</th>
                <th className="border px-2 py-1">담당</th>
                <th className="border px-2 py-1">완료일</th>
              </tr>
            </thead>
            <tbody>
              {improvements.map((r, idx) => (
                <tr key={idx}>
                  <td className="border px-2 py-1">{r.risk_element || "-"}</td>
                  <td className="border px-2 py-1">{r.improve_plan || "-"}</td>
                  <td className="border px-2 py-1">{r.owner || "-"}</td>
                  <td className="border px-2 py-1">{r.improve_date || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
